import { Injectable } from '@angular/core';
import { CHttp } from '../../core/services/chttp.service';
import { config } from '../../app.config';

enum Types {
  STAFF_INCENTIVE = 'Staff Incentive - Employment Stage Skipped',
  DISCOUNT = 'Discount - Employment Proof Required'
}

/** Sends promo-code administration requests through the authenticated HTTP client. */
@Injectable()
export class PromoCodeService {
  constructor(private http: CHttp) {}

  /** Lists promo codes with the supplied filters and pagination. */
  public getPromoCodes(data?: any) {
    return this.http.get(config.api_url + 'promo-codes', { params: data });
  }

  /** Fetches the promo code with the supplied ID. */
  public getPromoCode(id: string) {
    return this.http.get(config.api_url + 'promo-codes/' + id);
  }

  /** Creates a promo code from the edit form payload. */
  public addPromoCode(data: any) {
    return this.http.post(config.api_url + 'promo-codes', data);
  }

  /** Updates the promo code identified by the edit form payload. */
  public updatePromoCode(data: any) {
    return this.http.put(config.api_url + 'promo-codes/' + data.id, data);
  }

  /** Deletes the promo code with the supplied ID. */
  public deletePromoCode(id: string) {
    return this.http.delete(config.api_url + 'promo-codes/' + id);
  }

  public getTypeReadable(type) {
    return Types[type] || type;
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/promo-code/services/promo-code.service.ts